
<template>
  <div>
    <template v-if="interests.length && interests[0].item">
      <v-row class="ml-3 ml-md-0 mr-0 my-0 pa-0">
        <p class="text-h6 font-weight-bold orange--text mt-3 mt-sm-1 mb-1">{{ $t("researcher.interests") }}</p>
      </v-row>
      <v-row wrap v-for="(item, index) in interests" :key="'l'+index" class="ml-3 ml-md-0 mr-0 my-0 pa-0 pa-0">
        <v-col cols="12" sm="10" md="10" lg="12" xl="12" :key="'a'+index" class=" ml-0 pl-0 mr-1">
          <div class="v-card v-sheet theme--light my-0 ml-1 pa-3">
            <p class="text-body-1 font-weight-bold  py-0 mb-0">{{item.title}}</p>
            <p class="ma-0 pa-0">{{item.item}}</p>
          </div>
        </v-col>
      </v-row>
    </template>
    <v-row  wrap class="ml-4 ml-md-1 mr-0 my-0 pa-0">
      <v-col cols="12" class="text-xs-start ma-0 pa-0">
        <a v-if="cv" :href="cv" target="_blanc">
          <v-btn color="orange" class="mr-2">cv</v-btn>
        </a>
        <a  v-if="homepage" :href="homepage" target="_blanc">
          <v-btn color="orange" >Home page</v-btn>
        </a>
      </v-col>
    </v-row>
  </div>
</template>
<script>
export default {
  props: ['interests', 'cv','homepage'],
}
</script>
